export default __webpack_public_path__ + "static/media/4.01ee6c83.jpg";